import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import '../Financial/Financial.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Financial = () => {
  // Sample data
  const data = {
    labels: ['2024-12-01', '2024-12-02', '2024-12-03', '2024-12-04', '2024-12-05', '2024-12-06', '2024-12-07', '2024-12-08', '2024-12-09', '2024-12-10', '2024-12-11', '2024-12-12'],
    datasets: [
      {
        label: 'Revenue',
        data: [120, 150, 140, 130, 160, 170, 165, 155, 145, 135, 175, 180], // Revenue data
        backgroundColor: '#5383ec', // Blue bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.2,
      },
      {
        label: 'Net Income',
        data: [30, 35, 25, 28, 40, 38, 36, 32, 34, 30, 42, 45], // Net Income data
        backgroundColor: '#58a65c', // Green bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.50, // Increased gap between bars
      },
      {
        label: 'EBITDA',
        data: [50, 55, 45, 48, 60, 58, 56, 52, 54, 50, 62, 65], // EBITDA data
        backgroundColor: '#f1bf42', // Yellow bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.50, // Increased gap between bars
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Financial Overview: Revenue, Net Income, EBITDA',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'white', // White background
        titleColor: 'black', // Title text color (you can change this if needed)
        bodyColor: 'black', // Body text color
        borderColor: 'black', // Border color
        borderWidth: 1, // Border width
        padding: 10, // Padding inside the tooltip
        caretSize: 5, // Size of the tooltip's arrow/caret
        cornerRadius: 4, // Rounded corners for the tooltip
      },
    },
    scales: {
      y: {
        display: false,
      },
      y1: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Value (in Millions)',
        },
        ticks: {
          callback: function (value) {
            return value + 'M';
          },
        },
        grid: {
          drawOnChartArea: false,
        },
      },
      x: {
        type: 'category',
        title: {
          display: true,
          text: 'Date',
        },
      },
    },
  };

  return (
    <div className='financial-container'>
      <h2>Financial Overview</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default Financial;

